import {AppLauncherApplication} from '../../app-launcher/model/app-launcher';
import {AppAssistanceRequestType} from './app-assistance-request-type';

export class App {

  private static readonly INVISEO_CONSULTANT_EMAIL = 'inviseo-consultant@financeactive.com';
  private static readonly INVISEO_BACKOFFICE_EMAIL = 'inviseo-backoffice@financeactive.com';
  private static readonly DEBT_CONSULTANT_EMAIL = 'insito-consultant@financeactive.com';
  private static readonly INSTITUTIONAL_HOUSING_EMAIL = 'habitat-institutionnel@financeactive.com';
  private static readonly DEBT_PREMIUM_CONSULTANT_EMAIL = 'optimdette@financeactive.com';
  private static readonly DEBT_BACKOFFICE_EMAIL = 'insito-backoffice@financeactive.com';

  static readonly INSITO = new App('insito', 'Insito', ['insito-subscribe', 'insito-advertise']);
  static readonly SANTE = new App('insito_sante', 'Insito Santé', ['insito_sante-subscribe', 'insito_sante-advertise']);
  static readonly HABITAT = new App('insito_habitat', 'Insito Habitat', ['insito_habitat-subscribe', 'insito_habitat-advertise']);
  static readonly ALLIANCE = new App('alliance', 'Alliance', ['alliance-subscribe', 'alliance-advertise']);
  static readonly INVISEO = new App('inviseo', 'Inviseo', ['inviseo-subscribe', 'inviseo-advertise']);
  static readonly FISCALITE = new App('fiscalite', 'Fiscalité', ['fiscalite-subscribe', 'fiscalite-advertise']);
  static readonly OBSERVATORY = new App('observatory', 'Observatoire', ['insito-subscribe', 'insito-advertise']);
  static readonly DOTATIONS = new App('dotations', 'Dotations', []);
  static readonly SUBSIDIES = new App('subsidies', 'Subsidies', []);
  static readonly TREASURY = new App('treasury', 'Treasury', []);
  static readonly GRANTS = new App('grants', 'grants', []);
  // label must match the `application.name` column of optim-repository-back (see V2024_11_20_01__add_hive_app.sql), used by App.getByLabel
  static readonly APOLLO = new App('apollo', 'Fairways Debt', []);

  static readonly allApps = [App.INSITO,
                             App.HABITAT,
                             App.SANTE,
                             App.ALLIANCE,
                             App.INVISEO,
                             App.FISCALITE,
                             App.OBSERVATORY,
                             App.DOTATIONS,
                             App.SUBSIDIES,
                             App.TREASURY,
                             App.GRANTS,
                             App.APOLLO];

  key: string;
  label: string;
  tags: string[];

  private constructor(key: string, label: string, tags: string[]) {
    this.key = key;
    this.label = label;
    this.tags = tags;
  }

  static getByAppId(appId: string): App | undefined {
    return App.allApps.find(app => app.key === appId);
  }

  static getByLabel(label: string): App | undefined {
    return App.allApps.find(app => app.label === label);
  }

  static getAssistanceRequestMailAddress(application: AppLauncherApplication,
                                         requestType: AppAssistanceRequestType,
                                         isClientDettePremium: boolean,
                                         hasHabitatAccess = false): string | undefined {
    const app = App.getByAppId(application.appId);
    if (!app) {
      return this.DEBT_CONSULTANT_EMAIL;
    }

    if (hasHabitatAccess || app === App.HABITAT || app === App.APOLLO) {
      return this.INSTITUTIONAL_HOUSING_EMAIL;
    }

    if (AppAssistanceRequestType.CONSULTANT === requestType) {
      return this.getAssistanceEmailForConsultantRequest(app, isClientDettePremium);
    }

    return this.getEmailForBackofficeUpdate(app);
  }

  private static getAssistanceEmailForConsultantRequest(app: App, isClientDettePremium: boolean) {
    if (app === App.DOTATIONS || app === App.INVISEO) {
      return this.INVISEO_CONSULTANT_EMAIL;
    } else {
      return isClientDettePremium ? this.DEBT_PREMIUM_CONSULTANT_EMAIL : this.DEBT_CONSULTANT_EMAIL;
    }
  }

  private static getEmailForBackofficeUpdate(app: App) {
    if (app === App.INVISEO) {
      return this.INVISEO_BACKOFFICE_EMAIL;
    } else if (app === App.DOTATIONS) {
      return this.INVISEO_CONSULTANT_EMAIL;
    } else {
      return this.DEBT_BACKOFFICE_EMAIL;
    }
  }
}
